import styled, { keyframes } from "styled-components";

const spinnerKeyFrames = keyframes`
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;
export const Spinner = styled.div`
  display: inline-block;
  box-sizing: border-box;
  height: 100%;
  min-height:2.5vh;
  aspect-ratio: 1/1;
  border-radius: 50%;
  border: 4px solid ${({ theme }) => theme.main};
  border-bottom-color: ${({ theme }) => theme.bgColor};
  border-top-color: ${({ theme }) => theme.bgColor};
  animation: ${spinnerKeyFrames} 1.2s linear infinite;
`;
